import React, {useState, useContext} from 'react';
import Spinner from '../../../Spinner/Spinner';
import swal from 'sweetalert';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../../Context/MadricContext';
import { updateToDoList, deleteToDoList } from '../../../../services/MadricService';
import UpdateToDoListHistoriqueView from './UpdateTodolistHistoriqueView';

/**
 * Permet l'ajout des médias
 * @return {JSX}
 */
function UpdateTodolistHistorique(props) {
  const [isLoading, setIsLoading] = useState(false);
  const {projectInfo, setProjectInfo, setWhatToShow} = useContext(MadricContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [inputValue, setInputValue] = useState(location.state.todolist.description);
  const [complete, setComplete] = useState(location.state.todolist.complete);
  const [errors, setErrors] = useState('');


  /**
   * Ferme le modal
   */
  function closeModal() {
    if(location.state.returnTo === 'global')
    {
      navigate('/InfoGlobal');
    }
    else if(location.state.returnTo === 'historique')
    {
      setWhatToShow('7');
      navigate('/chantier/' + location.state.id);
    }
    else
    {
      setWhatToShow('1');
      navigate('/chantier/' + location.state.id);
    }

  }

  const handleSubmit = async (event) => {

    if (inputValue === '' || inputValue === null) {
        setErrors('La description de la tâche ne peut pas être vide.');
      } else {
        setIsLoading(true);
  
        const res = await updateToDoList(location.state.todolist.id, inputValue, complete);
  
        setProjectInfo((previous) => previous.map((item) => {
          if (item.id === location.state.todolist.id && item.type === 'todolist') {
            return res;
          }
          return item;
        }).sort((a, b) => (a.complete === b.complete) ? 0 : a.complete ? 1 : -1));
        setIsLoading(false);
      }

      if(location.state.returnTo === 'global')
      {
        navigate('/InfoGlobal');
      }
      else if(location.state.returnTo === 'historique')
      {
        setWhatToShow('7');
        navigate('/chantier/' + location.state.id);
      }
      else
      {
        setWhatToShow('1');
        navigate('/chantier/' + location.state.id);
      }

  };

  async function handleDelete() {
    swal({
      title: '!! Êtes-vous sûre de vouloir supprimer cette tâche !!',
      text: 'Une fois supprimé vous perderez cette tâche',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });

            setProjectInfo((prevItems) => prevItems.filter((item) => item.type === 'todolist' && item.id !== location.state.todolist.id));
            setIsLoading(true);
            await deleteToDoList(location.state.todolist.id);
            setIsLoading(false);

            if(location.state.returnTo === 'global')
            {
              navigate('/InfoGlobal');
            }
            else if(location.state.returnTo === 'historique')
            {
              setWhatToShow('7');
              navigate('/chantier/' + location.state.id);
            }
            else
            {
              setWhatToShow('1');
              navigate('/chantier/' + location.state.id);
            }
            
          } else {
            swal('Annulé!');
          }
        });
  }

 

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <UpdateToDoListHistoriqueView
        inputValue={inputValue}
        setInputValue={setInputValue}
        closeModal={closeModal}
        complete={complete}
        setComplete={setComplete}
        errors={errors}
        handleSubmit={handleSubmit}
        handleDelete={handleDelete}
      />
    </React.Fragment>
  );
}

export default UpdateTodolistHistorique;
